// extracted by mini-css-extract-plugin
export var centerText = "_ex-8";
export var container = "_ex-0";
export var doughnutContainer = "_ex-7";
export var legend = "_ex-a";
export var legendItemColorDisplay = "_ex-b";
export var legendItemLabel = "_ex-d";
export var legendItemValue = "_ex-c";
export var lg = "_ex-5";
export var maxWidth = "_ex-9";
export var md = "_ex-4";
export var responsive = "_ex-6";
export var sm = "_ex-3";
export var xs = "_ex-2";
export var xxs = "_ex-1";